import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'nallian-shared-ui/lib/components';
import HasSomeRights from 'nallian-shared-ui/lib/layout/rights/HasSomeRights';
import { Table } from 'semantic-ui-react';

const USER_GROUP_UNASSIGN_MEMBER_RIGHTS = [
  'user-groups/unassign/own-organisation',
  'user-groups/unassign/system-organisation',
  'user-groups/unassign/non-system-organisation',
];

const UserGroupMember = ({ member, handleRemoveMember }) => {
  const handleRemove = useCallback(() => handleRemoveMember(member.id), [
    member,
    handleRemoveMember,
  ]);
  return (
    <Table.Row key={member.id}>
      <Table.Cell width="6">{member.principal?.fullName}</Table.Cell>
      <Table.Cell width="4" textAlign="right">
        <HasSomeRights rights={USER_GROUP_UNASSIGN_MEMBER_RIGHTS}>
          <Icon iconbutton name="trash" onClick={handleRemove} />
        </HasSomeRights>
      </Table.Cell>
    </Table.Row>
  );
};

UserGroupMember.propTypes = {
  member: PropTypes.object.isRequired,
  handleRemoveMember: PropTypes.func.isRequired,
};

export default UserGroupMember;
